import {useQuery} from "@tanstack/react-query";
import {REPORT_ENDPOINTS} from "../../services/network/endpoints";
import {ReportAPI} from "../../services/network/report-api";

export function useFetchReportsPlanChartData(owner: string, section: string, param: string, enabled: boolean) {

    const {data, error, isLoading} = useQuery({
        queryKey: [REPORT_ENDPOINTS.FETCH_PLAN_CHART_DATA, owner, section, param],
        queryFn: () => ReportAPI.fetchPlanChartData(owner, section, param),
        enabled: Boolean(owner && section && param && enabled)
    });

    return {
        reportsPlanChartData: data?.data,
        reportsPlanChartError: error,
        reportsPlanChartIsLoading: isLoading,
    };
}